<script setup lang="ts">
	import { useUserPosition } from "@/composables/useUserPosition";
	import { onMounted } from "vue";

	const { enableGeolocation } = useUserPosition();

	const eventTypes = ["click", "touchstart", "scroll", "wheel", "mousedown"];

	function enable() {
		enableGeolocation();
		eventTypes.forEach((eventType) => {
			window.removeEventListener(eventType, enable);
		});
	}

	onMounted(() => {
		// Watch for first user interaction before enabling geolocation
		// (browsers require this to prevent abuse)
		eventTypes.forEach((eventType) => {
			window.addEventListener(eventType, enable);
		});
	});
</script>

<template>
	<span class="hidden" />
</template>
